import { fetch } from '@utils/utils';

export const getAddressPartItems = async (part: string, additionalFilter?: any): Promise<any> => {
  const sorting0 = '&sorting%5B0%5D.sort=order&sorting%5B0%5D.order=ASC';
  const sorting1 = '&sorting%5B1%5D.sort=name&sorting%5B1%5D.order=ASC';
  const filter0 = '&filter%5B0%5D.field=active&filter%5B0%5D.operation=EQ&filter%5B0%5D.value=true';
  const filter1 = additionalFilter
    ? `&filter%5B1%5D.field=${additionalFilter.field}&filter%5B1%5D.operation=EQ&filter%5B1%5D.value=${additionalFilter.value}`
    : '';

  try {
    const response: any = await fetch(
      `/metropolis/api/common/${part}?pageSize=9999${sorting0}${sorting1}${filter0}${filter1}`,
      {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' })
      }
    );

    const responseJson = await response.json();

    return responseJson.items;
  } catch (err) {
    return [];
  }
};

export const getCoords = ({ addError }) => async address => {
  try {
    const response = await fetch('/metropolis/api/common/iszr/address/find-coords', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(address)
    });
    const coords = await response.json();
    return coords;
  } catch (err) {
    addError('Souřadnice nenalezeny');
    return [];
  }
};



// WEBPACK FOOTER //
// ./src/components/form/Address/_addressActions.ts